import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { Category } from '@fcom/dapi/api/models/category';
import { getIconForServiceCategory } from '@fcom/dapi/utils/service-category-utils';

import { isBundle } from './category.utils';

export type BookingSummaryAncillaryKey =
  | 'purchase.payment.seatCount'
  | 'purchase.payment.baggageCount'
  | 'purchase.payment.mealCount'
  | 'purchase.payment.wifiCount'
  | 'purchase.payment.loungeCount'
  | 'purchase.payment.coverCount'
  | 'purchase.payment.sportCount'
  | 'purchase.payment.petCount'
  | 'purchase.payment.cabinBaggageCount'
  | 'purchase.payment.bundleCount'
  | 'purchase.payment.priorityCount';

export interface ServiceMapping {
  category: Category;
  icon: SvgLibraryIcon;
  bookingSummaryKey: BookingSummaryAncillaryKey;
}

export const serviceCategories = [
  Category.CABIN_BAGGAGE,
  Category.BAGGAGE,
  Category.MEAL,
  Category.SEAT,
  Category.WIFI,
  Category.LOUNGE,
  Category.SPORT,
  Category.PET,
  Category.COVER,
  Category.SEAT_WIFI,
  Category.SEAT_CABIN_BAGGAGE,
  Category.SEAT_MEAL,
  Category.SEAT_PRIORITY,
  Category.LOUNGE_CABIN_BAGGAGE,
  Category.LOUNGE_WIFI,
  Category.LOUNGE_PRIORITY,
  Category.WIFI_MEAL,
  Category.PRIORITY,
];
export const serviceMapping: ServiceMapping[] = serviceCategories.map((category) => ({
  category,
  icon: getIconForServiceCategory(category),
  bookingSummaryKey: `purchase.payment.${isBundle(category) ? 'bundle' : category}Count` as BookingSummaryAncillaryKey,
}));
